if (!customElements.get('mega-menu-sidebar')) {
    /**
    * MegaMenuSidebar Class - V2.0 (Hybrid Logic)
    * Handles tab-like interactions for complex multi-level menus.
    * - Supports "simple" layouts (L2 tabs -> L2 content).
    * - Supports "complex" layouts with a hybrid structure:
    * - L2 items can be dropdowns for L3 sub-tabs.
    * - L2 items can also be direct tabs themselves.
    */
    class MegaMenuSidebar extends HTMLElement {
    constructor() {
    super();
    this.isSimpleLayout = this.classList.contains('menu-layout--simple');
    this.contentPanes = this.querySelectorAll('.mega-menu-content-pane');
    }

    connectedCallback() {
    // Use a small timeout to ensure all DOM elements are ready
    setTimeout(() => {
    if (this.isSimpleLayout) {
    this.initSimpleMenu();
    } else {
    this.initComplexMenu();
    }
    }, 100);
    }

    /**
    * Initializes a simple L2 tab menu (e.g., Baby Monitor).
    */
    initSimpleMenu() {
    const tabLinks = this.querySelectorAll('.l2-link-simple');
    tabLinks.forEach(link => {
    link.addEventListener('mouseover', () => this.activateTab(link, tabLinks));
    });
    }

    /**
    * Initializes a complex hybrid menu (e.g., Security Cameras).
    */
    initComplexMenu() {
    const l2Tabs = this.querySelectorAll('.l2-summary--tab');
    const l3Links = this.querySelectorAll('.l3-link');
    const allL2Containers = this.querySelectorAll('.l2-summary, .l2-summary--tab');

    // L2 items that are direct tabs (e.g., Indoor Security)
    l2Tabs.forEach(tab => {
    tab.addEventListener('mouseover', () => {
    this.deactivateAll(allL2Containers, l3Links);
    tab.classList.add('active');
    this.activatePane(tab.dataset.target);
    });
    });

    // L2 items that contain L3 links (e.g., Outdoor Security)
    this.querySelectorAll('.l2-summary:not(.l2-summary--tab)').forEach(summary => {
    summary.addEventListener('mouseover', () => {
    if (summary.classList.contains('active')) return; // Already managing this section
    this.deactivateAll(allL2Containers, l3Links);
    summary.classList.add('active');
    // Activate the first L3 link within this L2 group
    const firstL3 = summary.closest('details').querySelector('.l3-link');
    if (firstL3) {
    firstL3.classList.add('active');
    this.activatePane(firstL3.dataset.target);
    }
    });
    });

    // L3 sub-tabs
    l3Links.forEach(link => {
    link.addEventListener('mouseover', () => this.activateTab(link, l3Links));
    });
    }

    /**
    * Activates a tab and its corresponding content pane.
    * @param {HTMLElement} tabElement - The tab element that was hovered.
    * @param {NodeListOf<Element>} siblingTabElements - A list of tabs to consider its siblings for deactivation.
        */
        activateTab(tabElement, siblingTabElements) {
        if (!tabElement.dataset.target || tabElement.classList.contains('active')) {
        return;
        }
        siblingTabElements.forEach(el => el.classList.remove('active'));
        tabElement.classList.add('active');
        this.activatePane(tabElement.dataset.target);
        }

        /**
        * Activates a single content pane by its ID.
        * @param {string} targetPaneId - The ID of the pane to activate (e.g., "#pane-123").
        */
        activatePane(targetPaneId) {
        this.contentPanes.forEach(pane => pane.classList.remove('active'));
        if (targetPaneId) {
        const targetPane = this.querySelector(targetPaneId);
        if (targetPane) {
        targetPane.classList.add('active');
        }
        }
        }

        /**
        * Deactivates all active tabs and summaries across the menu.
        */
        deactivateAll(l2s, l3s) {
        l2s.forEach(el => el.classList.remove('active'));
        l3s.forEach(el => el.classList.remove('active'));
        }
        }
        customElements.define('mega-menu-sidebar', MegaMenuSidebar);
        }